import { atom, useAtom } from "jotai";

export const isGAInitialisedAtom = atom<boolean>(false);

export default function useIsGAInitialised() {
  const [isGAInitialised] = useAtom(isGAInitialisedAtom);

  return isGAInitialised;
}
